import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Select from 'react-select';
import { arrowRenderer, clearRenderer } from '@lightspeed/cirrus-autocomplete';
import { getRegionList } from './utils';

const baseClass = 'cr-dropdown';
const dropdownClass = 'cr-dropdown-region';

const RegionDropdown = props => {
  const {
    countryCode,
    regionCode,
    onChange,
    isNotranslate = true,
    placeholder = 'Select a Region',
    className,
    ...rest
  } = props;

  const options = getRegionList(countryCode);

  const noTranslateProps = isNotranslate
    ? {
        optionRenderer: option => <var>{option.regionName}</var>,
        valueRenderer: option => <var>{option.regionName}</var>,
      }
    : {};

  const selectClass = cn(baseClass, dropdownClass, className);

  return (
    <div data-test="region-dropdown">
      <Select
        className={selectClass}
        {...rest}
        {...noTranslateProps}
        labelKey="regionName"
        valueKey="regionCode"
        placeholder={placeholder}
        optionHeight={36}
        options={options}
        noResultsText={null}
        value={regionCode}
        arrowRenderer={arrowRenderer}
        clearRenderer={clearRenderer}
        onChange={onChange}
        onFocus={e => {
          const TOP_BAR_HEIGHT = 66;
          const isTouch = 'ontouchstart' in document.documentElement;

          // On touch devices, we want to scroll to the top of the input when focusing,
          // else in most cases the keyboard will overlay the dropdown menu.
          if (isTouch) {
            const elementPosition = e.target.getBoundingClientRect();
            window.scroll({
              top: elementPosition.top + window.scrollY - TOP_BAR_HEIGHT,
            });
          }
        }}
      />
    </div>
  );
};

RegionDropdown.propTypes = {
  regionCode: PropTypes.string,
  countryCode: PropTypes.string,
  onChange: PropTypes.func,
  isNotranslate: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default RegionDropdown;
